module.exports = __webpack_public_path__ + "static/media/mg.460630b6.webp";